import { memoize } from 'lodash-es';

import { IHeaderBidder, IPublisher } from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { IMenuList } from '~/src/dash/types/menuList';
import { isSamsungPublisher, isPremionPublisher } from '~/src/dash/utils/ui';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { PID } from '~/src/dash/utils/publishers';
import { DemandSources } from '~/src/dash/globals/demand-sources';
export interface IHeaderBidderAdapter {
  key: string;
  text: string;
}

export const multiIndexBidders: string[] = [
  DemandSources.apsGuarantee,
  DemandSources.apsOpenAuction,
  DemandSources.apsPMP,
  DemandSources.rokuHB,
];

export function getHeaderBidderAdaptersForPublisher(
  sspStr: string,
  showAllBidders: boolean,
  publisher?: IPublisher,
  isSuperUser?: boolean,
  isDashboard?: boolean,
): IHeaderBidderAdapter[] {
  const shouldShowAll = showAllBidders || publisher?.ID === PID.publica;

  let headerBidderAdapters: IHeaderBidderAdapter[] = [
    { key: DemandSources.acuity, text: 'Acuity' },
    { key: DemandSources.admixer, text: 'Admixer' },
    { key: DemandSources.amazonORTB, text: 'Amazon ORTB' },
    { key: DemandSources.appnexus, text: 'Xandr' },
    { key: DemandSources.beachfront, text: 'Beachfront' },
    { key: DemandSources.cadent, text: 'Cadent, Aperture MX' },
    { key: DemandSources.column6, text: 'Column6' },
    { key: DemandSources.connatix, text: 'Connatix' },
    { key: DemandSources.criteo, text: 'Criteo' },
    { key: DemandSources.dynamicPlatformConnection, text: 'Dynamic Platform Connection' },
    { key: DemandSources.elementaltv, text: 'Elemental TV' },
    { key: DemandSources.epsilon, text: 'Epsilon' },
    { key: DemandSources.finecast, text: 'Finecast' },
    { key: DemandSources.freewheel, text: 'Freewheel SFX VAST' },
    { key: DemandSources.freewheelssp, text: 'FreeWheel oRTB' },
    { key: DemandSources.gumgum, text: 'GumGum' },
    { key: DemandSources.improvedigital, text: 'Azerion' },
    { key: DemandSources.indexExchange, text: 'Index Exchange' },
    { key: DemandSources.inmobi, text: 'InMobi' },
    { key: DemandSources.iponweb, text: 'The MediaGrid' },
    { key: DemandSources.krush, text: 'Krush' },
    { key: DemandSources.madhive, text: 'MadHive' },
    { key: DemandSources.magnitectv, text: 'Magnite CTV' },
    { key: DemandSources.marketingarchitects, text: 'Marketing Architects' },
    { key: DemandSources.medianet, text: 'Media.net' },
    { key: DemandSources.mezzo, text: 'Mezzo' },
    { key: DemandSources.mobilefuse, text: 'MobileFuse' },
    { key: DemandSources.motiv, text: 'Motiv' },
    { key: DemandSources.nexstar, text: 'VGI CTV' },
    { key: DemandSources.nhnace, text: 'NHNAce' },
    { key: DemandSources.nobid, text: 'NoBid' },
    { key: DemandSources.openx, text: 'OpenX' },
    { key: DemandSources.origin, text: 'Origin Media' },
    { key: DemandSources.platformConnection, text: 'Fixed Price Platform Connection' },
    { key: DemandSources.publicaCampaign, text: 'Direct Campaign' },
    { key: DemandSources.pubmatic, text: 'Pubmatic' },
    { key: DemandSources.pulsepoint, text: 'Pulsepoint' },
    { key: DemandSources.rhythmone, text: 'Nexxen CTRL' },
    { key: DemandSources.rubicon, text: 'Rubicon' },
    { key: DemandSources.sabio, text: 'Sabio' },
    { key: DemandSources.sharethrough, text: 'Sharethrough' },
    { key: DemandSources.smaato, text: 'Smaato' },
    { key: DemandSources.smart, text: 'SmartRTB' },
    { key: DemandSources.smartadserver, text: 'Smart Ad Server' },
    { key: DemandSources.smartclip, text: 'SmartClip' },
    { key: DemandSources.smartstream, text: 'SmartStream' },
    { key: DemandSources.smartyads, text: 'SmartyAds' },
    { key: DemandSources.sonobi, text: 'Sonobi' },
    { key: DemandSources.sovrn, text: 'Sovrn' },
    { key: DemandSources.stroer, text: 'Stroer' },
    { key: DemandSources.tappx, text: 'TappX' },
    { key: DemandSources.teads, text: 'Teads' },
    { key: DemandSources.telaria, text: 'Telaria' },
    { key: DemandSources.theviewpoint, text: 'TheViewPoint' },
    { key: DemandSources.triplelift, text: 'TripleLift' },
    { key: DemandSources.trustx, text: 'TrustX' },
    { key: DemandSources.undertone, text: 'Undertone' },
    { key: DemandSources.verizon, text: 'Yahoo' },
    { key: DemandSources.vibe, text: 'Vibe' },
    { key: DemandSources.videobyte, text: 'Kargo' },
    { key: DemandSources.videoHeroesFixedCPM, text: 'VideoHeroes Fixed CPM' },
    { key: DemandSources.videoHeroesRevShare, text: 'VideoHeroes Rev Share' },
    { key: DemandSources.vrtcal, text: 'Vrtcal' },
    { key: DemandSources.wurl, text: 'Wurl' },
    { key: DemandSources.yieldmo, text: 'Yieldmo' },
    { key: DemandSources.zedo, text: 'Zedo' },
  ];
  // some bidder adapters were removed as per CTV-4568

  if (sspStr !== '') {
    const ssp = sspStr.split(',');
    headerBidderAdapters = headerBidderAdapters.filter((hba: IHeaderBidderAdapter) =>
      ssp.includes(hba.key),
    );
  }

  // Add bidders that only appears on some publishers
  // If showAllBidders or isSuperUser is true, push all bidders to headerBidderAdapters

  if (isSuperUser) {
    // this is for load testing only hence only exposed to super user
    headerBidderAdapters.push({
      key: 'thin',
      text: 'LoadTest',
    });
  }

  // Roku HB bidder (Philo, DirectTVStreaming.  Publica/Publica QA for testing)
  if (
    ['381', '804', '1', '760', '518', '716'].includes((publisher || { ID: '0' }).ID) ||
    isSuperUser ||
    shouldShowAll
  ) {
    headerBidderAdapters.push({
      key: DemandSources.rokuHB,
      text: 'Roku HB',
    });
  }
  // Magnite bidder (unity only)
  if ((publisher || { ID: '0' }).ID === '558' || isSuperUser || shouldShowAll) {
    headerBidderAdapters.push({
      key: DemandSources.magnite,
      text: 'Magnite',
    });
  }
  // VAST bidder
  if (
    (publisher || { Reseller: { ID: '0' } }).Reseller &&
    (publisher || { Reseller: { ID: '0' } }).Reseller.ID === '4'
  ) {
    headerBidderAdapters.push({
      key: DemandSources.publica,
      text: 'Test Bidder',
    });
  } else {
    headerBidderAdapters.push({
      key: DemandSources.publica,
      text: 'Other (VAST tag)',
    });
  }
  // publishers with EnableAPSDemand toggled on
  if ((publisher && EBool.isTrue(publisher.EnableAPSDemand)) || isSuperUser || shouldShowAll) {
    headerBidderAdapters.push({
      key: DemandSources.apsOpenAuction,
      text: 'APS Open Auction',
    });
    headerBidderAdapters.push({
      key: DemandSources.apsPMP,
      text: 'APS PMP',
    });
    headerBidderAdapters.push({
      key: DemandSources.apsGuarantee,
      text: 'APS Guarantee',
    });
  }
  // Pubs with existing consumable bidders and super-users only
  if (
    ['39', '457', '476', '518', '544', '600', '614'].includes((publisher || { ID: '0' }).ID) ||
    isSuperUser ||
    shouldShowAll
  ) {
    headerBidderAdapters.push({
      key: DemandSources.consumable,
      text: 'Consumable',
    });
  }

  // Samsung-only bidders
  if (isSamsungPublisher(publisher?.ID) || isSuperUser || shouldShowAll) {
    headerBidderAdapters.push(
      {
        key: DemandSources.samsungssp,
        text: 'Samsung SSP',
      },
      {
        key: DemandSources.samsungssptest,
        text: 'Samsung SSP Test',
      },
    );
  }
  if (isSamsungPublisher(publisher?.ID) || shouldShowAll) {
    headerBidderAdapters.push(
      {
        key: DemandSources.samsungDSP,
        text: 'Samsung DSP',
      },
      {
        key: DemandSources.samsungAdManager,
        text: 'Samsung Ad Manager',
      },
    );
  }

  // Premion is Tegna's DSP
  if (isPremionPublisher(publisher?.ID) || shouldShowAll) {
    headerBidderAdapters.push({
      key: DemandSources.premion,
      text: 'Premion',
    });
  }

  // rokuORTB for DTVS, publica and kenny testing only (or super)
  if (['804', '1', '518'].includes((publisher || { ID: '0' }).ID) || isSuperUser || shouldShowAll) {
    headerBidderAdapters.push({ key: DemandSources.rokuORTB, text: 'RokuORTB' });
  }

  // OpenPathEnabled and super users can access TTD
  if (publisher?.OpenPathEnabled === EBool.EBool_TRUE || isSuperUser || shouldShowAll) {
    headerBidderAdapters.push({
      key: DemandSources.thetradedesk,
      text: 'The Trade Desk',
    });
  }

  // user with native vast enabled only
  if (isSuperUser || publisher?.NativeVastEnabled === EBool.EBool_TRUE || shouldShowAll) {
    headerBidderAdapters.push({
      key: DemandSources.nativeVast,
      text: 'Native VAST',
    });
  }

  if (isDashboard) {
    headerBidderAdapters.push({
      key: DemandSources.unruly,
      text: 'Nexxen CTRL',
    });
  }

  if ((publisher && publisher.EnableGatewayBidders === EBool.EBool_TRUE) || shouldShowAll) {
    headerBidderAdapters.push({
      key: DemandSources.dynamicGateway,
      text: 'Gateway - Dynamic Pricing',
    });
    headerBidderAdapters.push({
      key: DemandSources.gateway,
      text: 'Gateway',
    });
    headerBidderAdapters.push({
      key: DemandSources.gatewayTier0,
      text: 'Gateway Tier 0',
    });
  }

  headerBidderAdapters.sort((a: IHeaderBidderAdapter, b: IHeaderBidderAdapter) =>
    a.text.toUpperCase() > b.text.toUpperCase() ? 1 : -1,
  );
  return headerBidderAdapters;
}

export const unlistedHeaderBidderAdapters: IHeaderBidderAdapter[] = [
  { key: DemandSources.unruly, text: 'Nexxen CTRL' },
  { key: DemandSources.xandr, text: 'Xandr' },
  { key: DemandSources.yahoo, text: 'Verizon Media' },
];

function _headerBidderKeyToLabel(key: string, publisher: IPublisher): string {
  key = key.replace('NoApi', '');
  const adapter = getHeaderBidderAdaptersForPublisher('', false, publisher).find(
    (headerBidderAdapter) => headerBidderAdapter.key === key,
  );
  return adapter ? adapter.text : '';
}
export const headerBidderAdapterKeyToLabel = memoize(_headerBidderKeyToLabel);

// filters bidder adapters to show only those available in bidders passed in AND in headerBidderAdapters
const filterHeaderBidderAdaptersFromBidders = (
  publisher: IPublisher,
  bidders: IHeaderBidder[],
  isSuperUser: boolean,
): IHeaderBidderAdapter[] => {
  return getHeaderBidderAdaptersForPublisher('', false, publisher, isSuperUser).filter(
    (bidderAdapter: IHeaderBidderAdapter) => {
      return (bidders || []).reduce((ret: boolean, bidder: IHeaderBidder) => {
        // CTV-1470. need this bc console-api changes all verizon Bidder to yahoo
        if (bidder.Bidder === DemandSources.yahoo) {
          bidder.Bidder = DemandSources.verizon;
        }
        return ret || bidder.Bidder === bidderAdapter.key;
      }, false);
    },
  );
};

// make a new Demand Source Menu List and populate with selected bidder codes
export function genBiddersMenuList(
  existingBidderCodes: string[],
  publisher: IPublisher,
  bidders: IHeaderBidder[],
  allowedSSP: string,
  isSuperUser: boolean,
  useBidderFilter?: boolean,
): IMenuList {
  const bidderCodesAsIMenuList: IMenuList = {};
  let _bidderCodes: any[];

  if (useBidderFilter) {
    _bidderCodes = filterHeaderBidderAdaptersFromBidders(publisher, bidders, isSuperUser);
  } else {
    _bidderCodes = getHeaderBidderAdaptersForPublisher('', false, publisher, isSuperUser);
  }

  const sspList = allowedSSP.split(',');
  _bidderCodes
    .sort((a: IHeaderBidderAdapter, b: IHeaderBidderAdapter) => {
      if (a.key === DemandSources.publica) {
        return 1;
      } else if (b.key === DemandSources.publica) {
        return -1;
      } else {
        return a.text.localeCompare(b.text);
      }
    })
    .forEach((bidderCode: IHeaderBidderAdapter) => {
      if (allowedSSP === '' || sspList.includes(bidderCode.key)) {
        bidderCodesAsIMenuList[bidderCode.key] = {
          ID: bidderCode.key,
          title: bidderCode.text,
          selected: existingBidderCodes.includes(bidderCode.key),
        };
      }
    });

  return bidderCodesAsIMenuList;
}

// make a new Demand Source Select Options
export function genDemandSourcesOptions(
  publisher: IPublisher,
  bidders: IHeaderBidder[],
  allowedSSP: string,
  isSuperUser: boolean,
  useBidderFilter?: boolean,
): ISelectOption[] {
  const bidderCodesAsISelectOption: ISelectOption[] = [];
  let bidderCodes: IHeaderBidderAdapter[];

  if (useBidderFilter) {
    bidderCodes = filterHeaderBidderAdaptersFromBidders(publisher, bidders, isSuperUser);
  } else {
    bidderCodes = getHeaderBidderAdaptersForPublisher('', false, publisher, isSuperUser);
  }

  const sspList = allowedSSP.split(',');
  bidderCodes
    .sort((a, b) => {
      if (a.key === DemandSources.publica) {
        return 1;
      } else if (b.key === DemandSources.publica) {
        return -1;
      } else {
        return a.text.localeCompare(b.text);
      }
    })
    .forEach((bidderCode: IHeaderBidderAdapter) => {
      if (allowedSSP === '' || sspList.includes(bidderCode.key)) {
        bidderCodesAsISelectOption.push({
          id: bidderCode.key,
          label: bidderCode.text,
        });
      }
    });

  return bidderCodesAsISelectOption;
}

// convert IMenuList to comma separated string
export const exportDemandSourceListToString = (demandSourceList: IMenuList) => {
  const selectedDemandSources = [];
  for (const demandSource in demandSourceList) {
    if (demandSourceList[demandSource].selected) {
      selectedDemandSources.push(demandSourceList[demandSource].ID);
    }
  }
  return selectedDemandSources.filter((v) => v.length).join(',');
};
